// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"28398":"b6323009d4472833","28880":"51ce930283c4921a","36982":"4d6b1e618289a039","48846":"6438dbb375600f1b","64558":"3dd81c0e18a02d8d","85160":"401f49fea547e2d4","85177":"4596091eaf60e5b8"}[chunkId] + ".css";
};